import {useState} from 'react';
import {lockBody, unlockBody} from './Document';

export const useFilterMenu = (): [boolean, () => void] => {
    const [filterMenuOpen, setFilterMenuOpen] = useState<boolean>(false);

    const toggleFilterMenu = () => {
        if(filterMenuOpen) {
            unlockBody();
        } else {
            lockBody();
        }

        setFilterMenuOpen(open => !open);
    };

    return [filterMenuOpen, toggleFilterMenu];
};
